import { Box, Center, Table, Tbody, Td, Th, Thead, Tr, VStack } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { fetchInventoryLevels } from '../../api';
import AccessDenied from '../../components/AccessDenied';
import Loading from '../../components/Loading/Loading';
import TitleHeader from '../../components/TitleHeader';
import { useTableColors } from '../../Utils';

const InventoryLevels = () => {
    const { warehouseId } = useParams();
    const [inventory, setInventory] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const coolors = useTableColors()

    useEffect(() => {
        console.log("Warehouse ID:", warehouseId); // Check if warehouseId is correctly extracted
        fetchInventoryData();
    }, [warehouseId]);

    const fetchInventoryData = async () => {
        try {
            const result = await fetchInventoryLevels(warehouseId);
            if (result.success) {
                setInventory(result.data);
            } else {
                setError(result.error);
            }
        } catch (err) {
            console.error('Error fetching inventory:', err);
            setError('An error occurred while fetching inventory data.');
        }
        setLoading(false);
    };

    if (loading) {
        return (
            <Center mt="20">
                <Loading />
            </Center>
        );
    }

    if (error) {
        return <AccessDenied msg={error} />;
    }

    return (
        <Box maxW="full" mx="auto" >
            <VStack spacing={6} align="stretch">
                <TitleHeader title="Inventory Levels" />

                <Table variant="simple" size="sm">
                    <Thead bg={coolors.theadBg}>
                        <Tr>
                            <Th>#</Th>
                            <Th>Supply Item</Th>
                            <Th>Quantity on Hand</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {inventory.map((item, index) => (
                            <Tr
                                key={item.supplyItemId._id}
                                bg={index % 2 === 0 ? coolors.rowBgEven : coolors.rowBgOdd}
                                color={coolors.textColor}
                                _hover={{ bg: coolors.rowHoverBg, color: 'white' }}
                                borderBottom="1px solid"
                                borderColor={coolors.borderColor}
                            >
                                <Td>{index + 1}</Td>
                                <Td fontWeight="bold">{item.supplyItemId.name}</Td>
                                <Td>{item.quantity}</Td>
                            </Tr>
                        ))}
                    </Tbody>
                </Table>

            </VStack>
        </Box>
    );
};

export default InventoryLevels;
